module.exports = __webpack_public_path__ + "img/btn_order_bidv.baaf1247.svg";